import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMutationClient } from '../shared/hooks.js'
import FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import * as uuid from 'uuid'
import { useNotifications } from '../shared/Notifications.js';




function DetailsAzureCard() {
  return (
    <Card className="shadow">
      <Card.Header className="card-title">
        <span>Datos cuenta de Microsoft Azure</span>
      </Card.Header>
      <Card.Body>
        <span>Próximamente</span>
      </Card.Body>
    </Card>
  )
}

function DetailsGCPCard({ onChange, isLoading, uuidGCP }) {

  const [gcpOicdName, setGcpOicdName] = useState('');
  const [gcpProyectId, setGcpProyectId] = useState('');
  const [gcpProyectNumber, setGcpProyectNumber] = useState('')
  const [gcpRegion, setGcpRegion] = useState('')

  const [errors, setErrors] = useState({})
  useEffect(() => {
    onChange({
      gcpOicdName,
      gcpProyectId,
      gcpProyectNumber,
      gcpRegion,
      isValid: validateFields(),
    });
  }, [gcpOicdName, gcpProyectId, gcpProyectNumber, gcpRegion]);

  const validateFields = () => {
    const newErrors = {};
    if (!gcpOicdName){
      newErrors.gcpOicdName = 'El nombre OICD es requerida';
    }
    if (!gcpProyectId){
      newErrors.gcpProyectId = 'La ID del proyeco es requerida';
    }
    if (!gcpProyectNumber){
      newErrors.gcpProyectNumber = 'El número del proyecto es requerido';
    }
    if (!gcpRegion){
      newErrors.gcpRegion = 'La región es requerida';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Card className="shadow">
      <Card.Header className="card-title">
        <span>Datos cuenta de Google Cloud Platform</span>
      </Card.Header>
      <Card.Body>
        <FormGroup>
          <Form.Label>Identificador unico de la implementación</Form.Label>
          <Form.Control
            type="text"
            value={uuidGCP}
            onChange={e =>{}}
            disabled={true}
          />
        </FormGroup>
        <FormGroup>
          <Form.Label>Nombre OICD</Form.Label>
          <Form.Control
            type="text"
            value={gcpOicdName}
            onChange={e => setGcpOicdName(e.target.value)}
            isInvalid={!!errors.gcpOicdName}
            disabled={isLoading}
          />
          <Form.Control.Feedback type="invalid">
            {errors.gcpOicdName}
          </Form.Control.Feedback>
        </FormGroup>
        <FormGroup>
          <Form.Label>Id proyecto</Form.Label>
          <Form.Control
              type="text"
              value={gcpProyectId}
              onChange={e => setGcpProyectId(e.target.value)}
              isInvalid={!!errors.gcpProyectId}
              disabled={isLoading}
            />
            <Form.Control.Feedback type="invalid">
              {errors.gcpProyectId}
            </Form.Control.Feedback>
        </FormGroup>
        <FormGroup>
          <Form.Label>Número del proyecto</Form.Label>
          <Form.Control
            type="text"
            value={gcpProyectNumber}
            onChange={e => setGcpProyectNumber(e.target.value)}
            isInvalid={!!errors.gcpProyectNumber}
            disabled={isLoading}
          />
          <Form.Control.Feedback type="invalid">
            {errors.gcpProyectNumber}
          </Form.Control.Feedback>
        </FormGroup>
        <FormGroup>
          <Form.Label>Región</Form.Label>
          <Form.Control
            type="text"
            value={gcpRegion}
            onChange={e => setGcpRegion(e.target.value)}
            isInvalid={!!errors.gcpRegion}
            disabled={isLoading}
          />
          <Form.Control.Feedback type="invalid">
            {errors.gcpRegion}
          </Form.Control.Feedback>
        </FormGroup>
      </Card.Body>
    </Card>
  )
}




function TrustDownloadButton({ awsIdAccount,setDownloaded }) {
  const [isLoading, setIsLoading] = useState(false)
  const mutationClient = useMutationClient()
  const notifications = useNotifications()

  useEffect(() => {
    async function download() {
      const res = await mutationClient.get(`logsdigitals/aws/files/trust/${awsIdAccount}`)
      setIsLoading(false)

      if (res.status === 200) {
        var blob = new Blob([JSON.stringify(res.data, null, 2)], { type: "application/json" });
        FileSaver.saveAs(blob, `trust-policy.json`);
        setDownloaded(true);
        notifications.success('El archivo de política de confianza se descargó correctamente.');
      } else {
        setDownloaded(false);
        notifications.danger('Ocurrió un error al descargar la política de confianza. Intenta nuevamente.');
      }
    }

    if (isLoading) {
      download()
    }
  }, [isLoading])

  return (
    <button
      className={`btn btn-primary d-none d-lg-inline-block ${isLoading ? "loading" : ""}`}
      onClick={() => setIsLoading(true)}
      disabled={isLoading || awsIdAccount ==''}
    >
      <FontAwesomeIcon icon={faDownload} className="mr-2" />
      {
        isLoading ?
          <span>Generando archivo.</span>
          :
          <span>Archivo politicas de confianza</span>
      }
    </button>
  )
}

function PolicyDownloadButton({ awsIdAccount,awsRegion,uuidAws,setDownloaded }) {
  const [isLoading, setIsLoading] = useState(false)
  const mutationClient = useMutationClient()
  const notifications = useNotifications()

  useEffect(() => {
    async function download() {
      const res = await mutationClient.get(`logsdigitals/aws/files/policies/${awsIdAccount}/${awsRegion}/${uuidAws}`)
      setIsLoading(false)

      if (res.status === 200) {
        var blob = new Blob([JSON.stringify(res.data, null, 2)], { type: "application/json" });
        FileSaver.saveAs(blob, `octoberus-${uuidAws}-${awsRegion}.json`);
        setDownloaded(true);
        notifications.success('El archivo de permisos  se descargó correctamente.');
      } else {
        notifications.danger('Ocurrió un error al descargar los permisos. Intenta nuevamente.');
        setDownloaded(false);
      }
    }

    if (isLoading) {
      download()
    }
  }, [isLoading])

  return (
    <button
      className={`btn btn-primary d-none d-lg-inline-block ${isLoading ? "loading" : ""}`}
      onClick={() => setIsLoading(true)}
      disabled={isLoading || awsIdAccount =='' || awsRegion == '' || uuidAws == ''}
    >
      <FontAwesomeIcon icon={faDownload} className="mr-2" />
      {
        isLoading ?
          <span>Generando archivo.</span>
          :
          <span>Archivo politicas (Permisos)</span>
      }
    </button>
  )
}

function DetailsAWSCard({ onChange, isLoading,uuidAws }) {

  const [awsRegion, setAwsRegion] = useState('');
  const [awsArnRol, setAwsArnRol] = useState('');
  const [awsIdAccount, setAwsIdAccount] = useState('')

  const [trustDownloaded, setTrustDownloaded] = useState(false);
  const [policyDownloaded, setFile2Downloaded] = useState(false);

  const [errors, setErrors] = useState({})
  useEffect(() => {
    onChange({
      awsRegion,
      awsArnRol,
      awsIdAccount,
      isValid: validateFields(),
    });
  }, [awsRegion, awsArnRol, awsIdAccount, trustDownloaded, policyDownloaded]);

  const validateFields = () => {
    const newErrors = {};
    if (!awsRegion){
      newErrors.awsRegion = 'La región es requerida';
    }
    if (!awsArnRol){
      newErrors.awsArnRol = 'El Arn del rol es requerido';
    }
    if (!awsIdAccount){
      newErrors.awsIdAccount = 'ID de Cuenta de AWS es requerido';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  return (
    <Card className="shadow">
      <Card.Header className="card-title">
        <span>Datos cuenta de Amazon Web Services</span>
      </Card.Header>
      <Card.Body>
        <FormGroup>
          <Form.Label>Identificador unico de la implementación</Form.Label>
          <Form.Control
            type="text"
            value={uuidAws}
            onChange={e =>{}}
            disabled={true}
          />
          <Form.Control.Feedback type="invalid">
            {errors.awsIdAccount}
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup>
          <Form.Label>ID de cuenta de AWS</Form.Label>
          <Form.Control
            type="text"
            value={awsIdAccount}
            onChange={e => setAwsIdAccount(e.target.value)}
            isInvalid={!!errors.awsIdAccount}
            disabled={isLoading}
          />
          <Form.Control.Feedback type="invalid">
            {errors.awsIdAccount}
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup>
          <Form.Label>Región</Form.Label>
          <Form.Control
            type="text"
            value={awsRegion}
            onChange={e => setAwsRegion(e.target.value)}
            isInvalid={!!errors.awsRegion}
            disabled={isLoading}
          />
          <Form.Control.Feedback type="invalid">
            {errors.awsRegion}
          </Form.Control.Feedback>
        </FormGroup>

        <FormGroup>
          <Form.Label>Descargar archivos requeridos</Form.Label>
          <Row className="mb-2">
            <Col className='text-center'>
              <TrustDownloadButton awsIdAccount ={awsIdAccount}  setDownloaded={setTrustDownloaded}/>
            </Col>
            <Col className='text-center'>
              <PolicyDownloadButton awsIdAccount ={awsIdAccount}  awsRegion={awsRegion}  uuidAws={uuidAws} setDownloaded={setFile2Downloaded}/>
            </Col>
          </Row>
        </FormGroup>



        <FormGroup>
          <Form.Label>Arn rol</Form.Label>
          <Form.Control
            type="text"
            value={awsArnRol}
            onChange={e => setAwsArnRol(e.target.value)}
            isInvalid={!!errors.awsArnRol}
            disabled={isLoading || !(trustDownloaded && policyDownloaded)}
          />
          <Form.Control.Feedback type="invalid">
            {errors.awsArnRol}
          </Form.Control.Feedback>
        </FormGroup>
        <span class="font-weight-bold">Es necesario agregar como proveedor de indetidad a github a su cuenta de AWS. Asegurese de ello antes de guardar</span>
      </Card.Body>
    </Card>
  );
}




export default function DigitalForm({ Digital, isLoading, save }) {
  const [name, setName] = useState(Digital.name || '')
  const [errors, setErrors] = useState({})
  const [digital_type, setDigitalTypeId] = useState(Digital.digital_type || '')
  const [uuidDigital] = useState(() => uuid.v4());
  const [awsDetails, setAwsDetails] = useState({
    awsRegion: '',
    awsArnRol: '',
    isValid: false
  });
  const [gcpDetails, setGcpDetails] = useState({
    isValid: false
  });


  function validate(e) {
    e.preventDefault()

    const validations = []

    if (!name) {
      validations.push(['name', 'Nombre es requerido'])
    }

    if (!digital_type) {
      validations.push(['digital_type', 'La plataforma es requerida'])
    }



    if (validations.length > 0) {
      setErrors(validations.reduce((acc, item) => ({ ...acc, [item[0]]: item[1] }), {}))
      return
    } else {
      setErrors([])

      const data = {
        name,
        digital_type: digital_type === '' ? null : digital_type,
        aws: awsDetails.isValid ? awsDetails : null,
        uuid:uuidDigital?uuidDigital: null
      }
      save(data)
    }
  }

  const isFormValid = () => {
    if (digital_type == "AWS") {
      return awsDetails.isValid && name.trim() !== '' && digital_type !== ''
    }
    return false
  };

  const platformOptions = [
    { value: 'AWS', label: 'Amazon Web Services' },
    { value: 'GCP', label: 'Google Cloud Platform' },
    { value: 'AZURE', label: 'Microsoft Azure' },
  ];
  const platformComponents = {
    "AWS": <DetailsAWSCard onChange={setAwsDetails} isLoading={isLoading} uuidAws={uuidDigital}/>,
    "GCP": <DetailsGCPCard  onChange={setGcpDetails} isLoading={isLoading} uuidGCP={uuidDigital} />,
    "AZURE": <DetailsAzureCard />,
  };


  return (
    <Form onSubmit={validate}>
      <Row className="mb-2 pb-4">
        <Col className="col-6">
          <Card className="shadow">
            <Card.Header className="card-title">
              <span>Datos general</span>
            </Card.Header>
            <Card.Body>
              <FormGroup>
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  isInvalid={!!errors.name}
                  disabled={isLoading}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </FormGroup>
              <FormGroup>
                <Form.Label>
                  <span>Plataforma</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  value={digital_type}
                  onChange={e => setDigitalTypeId(e.target.value)}
                  isInvalid={!!errors.digital_type}
                  disabled={isLoading || name.trim() == '' }
                >
                  <option value="">Seleccione una plataforma</option>
                  {platformOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.digital_type}
                </Form.Control.Feedback>
              </FormGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col className="col-6">
        {
          (name.trim() !== '' && platformComponents[digital_type])  || null
        }
        </Col>

        <Col className="col-12 d-flex justify-content-center align-items-center">
          <FormGroup className='pt-3'>
            <Button
              variant="primary"
              size="lg"
              disabled={isLoading || !isFormValid()}
              type="submit"
            >
              <span>Guardar</span>
            </Button>
          </FormGroup>
        </Col>

      </Row>
    </Form>
  )
}
